import React from 'react';
import Card from '../shared/Card';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCpu } = FiIcons;

const LEVEL_STYLES = {
  stable: 'text-emerald-600 bg-emerald-50 border-emerald-200',
  moderate: 'text-amber-600 bg-amber-50 border-amber-200',
  high: 'text-orange-600 bg-orange-50 border-orange-200',
  critical: 'text-rose-600 bg-rose-50 border-rose-200',
};

const DOMAIN_LABEL = {
  sepsis: 'Possible Sepsis',
  cardiac: 'Cardiac Deterioration',
  neurological: 'Neurological / Hypoxia',
  mental_health: 'Mental Health Risk',
  nutrition: 'Nutrition Risk',
  medication: 'Medication Risk',
};

// Placeholder — replace with real model output for the selected patient
// once Saheed's risk-scoring endpoint exists. Shape: one entry per domain.
const DEFAULT_SCORES = [
  { id: 'r1', domain: 'cardiac', level: 'moderate', confidence: 0.7, status: 'placeholder' },
];

const AIRiskPanel = ({ scores = DEFAULT_SCORES }) => (
  <Card className="space-y-3" title="AI Risk Panel">
    <div className="text-black text-lg font-bold">AI Risk</div>
    <div className="space-y-3">
      {scores.map((score) => (
        <div key={score.id} className="flex items-center justify-between rounded-xl bg-slate-800/40 border border-slate-700/50 px-4 py-3">
          <div>
            <p className="text-sm font-bold text-slate-100 capitalize">{DOMAIN_LABEL[score.domain] ?? score.domain}</p>
            <div className="flex items-center gap-1.5 mt-1">
              <div className="h-1 w-16 bg-slate-700 rounded-full overflow-hidden">
                <div className="h-full bg-primary-500 rounded-full" style={{ width: `${Math.round(score.confidence * 100)}%` }} />
              </div>
              <span className="text-[10px] text-slate-500 font-semibold">{Math.round(score.confidence * 100)}% confidence</span>
            </div>
          </div>
          <span className={`text-xs font-bold px-2.5 py-1 rounded-lg border uppercase ${LEVEL_STYLES[score.level] ?? LEVEL_STYLES.moderate}`}>
            {score.level}
          </span>
        </div>
      ))}
    </div>
    {scores[0]?.status !== 'live' && (
      <p className="mt-3 flex items-center gap-1.5 text-[11px] text-slate-500">
        <SafeIcon icon={FiCpu} className="text-xs" /> Awaiting AI/ML model integration — placeholder scores shown.
      </p>
    )}
  </Card>
);

export default AIRiskPanel;